export function parseLocalDateOnly(value) {
  if (!value || typeof value !== "string") return null;
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}

export function parseTrustBudDate(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const localDate = parseLocalDateOnly(value);
  if (localDate) return localDate;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatTrustBudDateLabel(value) {
  const date = parseTrustBudDate(value);
  if (!date) return "";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}

export function isSameLocalDate(left, right) {
  const leftDate = parseTrustBudDate(left);
  const rightDate = parseTrustBudDate(right);
  if (!leftDate || !rightDate) return false;
  return (
    leftDate.getFullYear() === rightDate.getFullYear() &&
    leftDate.getMonth() === rightDate.getMonth() &&
    leftDate.getDate() === rightDate.getDate()
  );
}

function startOfLocalDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function daysBetweenLocalDates(left, right) {
  const leftDate = parseTrustBudDate(left);
  const rightDate = parseTrustBudDate(right);
  if (!leftDate || !rightDate) return null;
  return Math.round(
    (startOfLocalDay(rightDate).getTime() - startOfLocalDay(leftDate).getTime()) / 86400000
  );
}

export function resolveSprintWindow({ endDate, localDate = null } = {}) {
  const parsedEndDate = parseTrustBudDate(endDate);
  const parsedLocalDate = parseTrustBudDate(localDate) || startOfLocalDay(new Date());
  if (!parsedEndDate) {
    return {
      endDate: null,
      endLabel: "",
      endsToday: false,
      hasEnded: false,
      daysRemaining: null,
      lifecycleSummary: null,
      endChipLabel: "",
      isExpired: false,
    };
  }

  const dayDelta = daysBetweenLocalDates(parsedLocalDate, parsedEndDate);
  const endLabel = formatTrustBudDateLabel(parsedEndDate);
  if (dayDelta === null) {
    return {
      endDate: null,
      endLabel: "",
      endsToday: false,
      hasEnded: false,
      daysRemaining: null,
      lifecycleSummary: null,
      endChipLabel: "",
      isExpired: false,
    };
  }
  if (dayDelta < 0) {
    return {
      endDate,
      endLabel,
      endsToday: false,
      hasEnded: true,
      daysRemaining: 0,
      lifecycleSummary: `This Accountability ended ${endLabel}`,
      endChipLabel: `Ended ${endLabel}`,
      isExpired: true,
    };
  }
  if (dayDelta === 0) {
    return {
      endDate,
      endLabel,
      endsToday: true,
      hasEnded: false,
      daysRemaining: 0,
    lifecycleSummary: "This Accountability ends today",
      endChipLabel: `Ends ${endLabel}`,
      isExpired: false,
    };
  }
  return {
    endDate,
    endLabel,
    endsToday: false,
    hasEnded: false,
    daysRemaining: dayDelta,
    lifecycleSummary: `${dayDelta} day${dayDelta === 1 ? "" : "s"} left in this Accountability`,
    endChipLabel: `Ends ${endLabel}`,
    isExpired: false,
  };
}
